const searchInOrgContextResponseActions = {
  SEARCH_IN_ORG_CONTEXT_RESPONSE_INIT_STATE_SET: 'SEARCH_IN_ORG_CONTEXT_RESPONSE_INIT_STATE_SET',
  SEARCH_IN_ORG_CONTEXT_RESPONSE_GET: 'SEARCH_IN_ORG_CONTEXT_RESPONSE_GET'
};
export default searchInOrgContextResponseActions;
